var _circle, _circle2, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    stroke: "#3D95CA",
    strokeOpacity: 0.08,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7351 38.625C49.7718 39.1017 49.6068 39.5966 49.2401 39.9633L38.2035 51C35.7651 53.4383 33.3085 53.4383 30.8518 51L23.5001 43.6483C22.2535 42.3833 21.6301 41.1183 21.6668 39.8533H21.7951L49.5151 38.6434L49.7351 38.625Z",
    fill: "#3270FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M49.2398 37.5065L35.7648 24.0315L34.1698 22.4365C33.6382 21.9048 32.7582 21.9048 32.2265 22.4365C31.6948 22.9681 31.6948 23.8481 32.2265 24.3798L33.8215 25.9748L23.4998 36.2965C22.3265 37.4698 21.7032 38.6615 21.6665 39.8531H21.7948L49.5148 38.6432L49.7348 38.6248C49.7165 38.2215 49.5332 37.7999 49.2398 37.5065Z",
    fill: "#3270FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3333 59.7083H23.5C22.7483 59.7083 22.125 59.0849 22.125 58.3333C22.125 57.5816 22.7483 56.9583 23.5 56.9583H47.3333C48.085 56.9583 48.7083 57.5816 48.7083 58.3333C48.7083 59.0849 48.085 59.7083 47.3333 59.7083Z",
    fill: "#3270FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.475 45.0968C52.9983 44.5835 52.1183 44.5835 51.6417 45.0968C51.0733 45.7201 48.25 48.91 48.25 51.3117C48.25 53.695 50.175 55.6201 52.5583 55.6201C54.9417 55.6201 56.8667 53.695 56.8667 51.3117C56.8667 48.91 54.0433 45.7201 53.475 45.0968Z",
    fill: "#3270FC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.15e3ed2485931b2be967942bacb738a2.svg";
export { ForwardRef as ReactComponent };